<template>
    <div :class="themeClass" class="vc-cart-controls">
        <button @click="cart.empty()" class="vc-cart-controls__button c-button c-button--no-transition">
            <font-awesome-icon class="vc-cart-controls__button__icon c-button__left-icon"
                               icon="trash-alt"></font-awesome-icon>
            Empty Cart
        </button>
        <span class="vc-cart-controls__separator">|</span>
        <button @click.stop="share()" class="vc-cart-controls__button c-button c-button--no-transition">
            <font-awesome-icon class="vc-cart-controls__button__icon c-button__left-icon"
                               icon="share-alt"></font-awesome-icon>
            Share
        </button>
    </div>
</template>

<script>
    export default {
        name: "cart-controls",
        props: {
            theme: {
                type: String,
                default: 'cartPopup',
                validator: function (value) {
                    return ['cartPopup', 'checkout'].indexOf(value) !== -1;
                }
            }
        },
        computed: {
            cart() {
                return this.$store.state.cart
            },
            themeClass() {
                return {
                    'vc-cart-controls--cart-popup-theme': this.theme === 'cartPopup',
                    'vc-cart-controls--checkout-theme': this.theme === 'checkout',
                }
            }
        },
        methods: {
            share() {
                $("#shareCartModal").modal('show');
            },
        }
    }
</script>

<style lang="scss" scoped>
    .vc-cart-controls {
        $cart-controls: &;
        display: flex;
        align-items: center;

        &__separator {
            margin: 0 10px;
        }

        &__button {
            font-size: 12px;
        }

        &--cart-popup-theme {
            #{$cart-controls} {
                &__separator {
                    color: var(--menu-item-text-color-faded-more);
                }

                &__button {
                    $button: &;
                    color: var(--menu-item-text-color);

                    &:hover {
                        color: var(--menu-item-hover-text-color);

                        #{$button}__icon {
                            color: var(--menu-item-hover-icon-color);
                        }
                    }

                    &:active {
                        color: var(--menu-item-active-text-color);

                        #{$button}__icon {
                            color: var(--menu-item-active-icon-color);
                        }
                    }

                    &__icon {
                        color: var(--menu-item-icon-color);
                    }
                }
            }
        }

        &--checkout-theme {
            #{$cart-controls} {
                &__separator {
                    color: var(--primary-text-color-faded-more);
                }

                &__button {
                    &, &:hover, &:active {
                        color: var(--secondary-text-color);
                    }
                }
            }
        }
    }
</style>